export const name = /^[a-zA-Z0-9 \-']+$/;